module.exports = __webpack_public_path__ + "static/travelzik5-1a582f52833a185e7302e7c6c4988fc7.png";